import React, { VFC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useTheme, Theme } from '@material-ui/core/styles';
import LogoImage from '../../../../shared/images/icons/logo.png';

const Img = styled.img<{ theme: Theme }>`
  width: 25px;
  height: auto;
  margin-right: ${({ theme }) => theme.spacing(1)};
  vertical-align: middle;
  border-style: none;
`;

interface Props {}
const SPLogo: VFC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return <Img src={LogoImage} alt={t('otetsutabi')} theme={theme} />;
};

export default SPLogo;
